import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {UnpaidAgentsFilter} from '../components/UnpaidAgentsFilter';
import {UnpaidAgentsTable} from '../components/UnpaidAgentsTable';
import {UnpaidAgentsFooter} from '../components/UnpaidAgentsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function UnpaidAgentsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'invoices-list-card'}>
      <UnpaidAgentsFilter/>
      <UnpaidAgentsTable/>
      <FooterBar>
        <UnpaidAgentsFooter/>
      </FooterBar>
    </Card>
  );
}
